
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[collectionName]",
      function () {
        return require("private-next-pages/collections/[collectionName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/[collectionName]"])
      });
    }
  